import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { Produtos } from '../_model/produtos';
import { MarcasService } from '../_services/marcas.service';
import { ProdutosService } from '../_services/produtos.service';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-noivas',
    templateUrl: './noivas.component.html',
    styleUrls: ['./noivas.component.less'],
    standalone: false
})
export class NoivasComponent implements OnInit {

  faEuroSign = faEuroSign;

  constructor(private marca: MarcasService, private prod: ProdutosService) { }

  filter: string = "";

  apiUrl: string = environment.apiUrl;

  marcas: Marcas[] = [];

  fm: Marcas[] = [];

  produtos: Produtos[] = [];

  fp: Produtos[] = [];

  pags: number = 1;

  current: number = 1;

  ngOnInit() {
    this.marca.list().subscribe((data: Marcas[]) => {
      this.marcas = [];
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
      });
      this.fm = this.marcas;
    });
    this.prod.list().subscribe((data: Produtos[]) => {
      this.produtos = [];
      data.forEach(el => {
        this.produtos.push(new Produtos(el));
      });
      this.produtos = this.produtos.filter(x => x.tipo.includes("noiva"));
      this.fp = this.produtos;
      this.pags = Math.floor(this.produtos.length / 8) + (this.produtos.length % 8 > 0 ? 1 : 0);
    });
  }

  checkMarcas(it: Marcas) {
    var temp = this.fm.filter(x => x.id == it.id);
    if(temp.length == 0){
      this.fm.push(new Marcas(it));
    }else{
      this.fm = this.fm.filter(x => x.id != it.id);
    }
    this.produtos = [];
    this.fp.forEach(el => {
      this.fm.forEach(it => {
        if(el.marcasId == it.id)
          this.produtos.push(new Produtos(el));
      });
    });
    this.pags = Math.floor(this.produtos.length / 8) + (this.produtos.length % 8 > 0 ? 1 : 0);
  }

  uncheckAll() {
    var len = this.marcas.length;
    for(var i = 0; i < len; i++) {
      var t: HTMLInputElement = (<HTMLInputElement> document.getElementById("ch"+i));
      t.checked = false;
    }
    this.fm = [];
    this.produtos = [];
    this.fp.forEach(el => {
      this.fm.forEach(it => {
        if(el.marcasId == it.id)
          this.produtos.push(new Produtos(el));
      });
    });
    this.pags = Math.floor(this.produtos.length / 8) + (this.produtos.length % 8 > 0 ? 1 : 0);
  }

}
